// Component: LoginModal
// Author: Priyanka
import * as React from 'react';
import LoginModalComponent from '@component/LoginModal';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';

export default function LoginModal(props) {
  var SignInButton = false;
  var RagisterButton = false;
  if (props.fields?.signInButton?.value) {
    SignInButton = <a href={props.fields?.signInButton?.value?.href}>SIGN IN</a>;
  }

  if (props.fields?.ragisterButton?.value) {
    RagisterButton = <a href={props.fields?.ragisterButton?.value?.href}>REGISTER</a>;
  }

  var LoginModalData = {
    TitleRight: <Text field={props.fields?.titleRight} />,
    DescriptionRight: <RichText field={props.fields?.descriptionRight} />,
    TitleLeft: <Text field={props.fields?.titleLeft} />,
    DescriptionLeft: <RichText field={props.fields?.descriptionLeft} />,
    SignInButton: SignInButton,
    RagisterButton: RagisterButton,
  };

  return (
    <>
      <LoginModalComponent {...LoginModalData} />
    </>
  );
}
